module.exports = __webpack_public_path__ + "9b73cbfa5bbf1a8dd0d3c90f582c7f91.svg";